import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import Rendertable from "./Rendertable";
import { getProductSearchResultforsales } from "../../../actions/productDetails";
import {
  getAllLocation,
  getAllLocationPlain,
} from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllAttributeTerm , getAllAttribute  } from "../../../actions/attributeAction";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  TreeSelect,
  Button,
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  categoryList,
  getAllCategory,
  getAllAttributeTerm,
  attributeTerms,
  getAllAttribute,
  attributes,
  Auth,
}) => {
  const [List, setList] = useState([]);
  const [locations, setLocations] = useState([]);
  const [reload, setreload] = useState(false);
  const [loading, setloading] = useState(true);
  const location = useRef("");
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_data = useRef({});
  const searchCategory = useRef("");
  const searchAttribute = useRef("");
  const User = useRef(Auth.superuser);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };
  const attributeTermTreeData = attributeTerms
    ? attributeTerms.map(term => ({
        title: term.name,
        value: term.id,
        key: term.id,
      }))
    : [];

    useEffect(() => {
      console.log("Attribute Terms:", attributeTerms);
    }, [attributeTerms]);
    

  useEffect(() => {
    getAllCategory();
    getAllAttributeTerm();
    getAllAttribute();
    getAllLocationPlain().then((result) => {
      setLocations(result);
    });
    getProductSearchResultforsales(
      keyward.current,
      location.current,
      pageno.current,
      page_size.current,
      searchCategory.current,
      searchAttribute.current
    ).then((result) => {
      total_data.current = {
        total_purchase_price: result.total_purchase_price,
        total_selling_price: result.total_selling_price,
        total_quantity: result.total_quantity,
        current_purchase_price: result.current_purchase_price,
        current_selling_price: result.current_selling_price,
        current_quantity: result.current_quantity,
      };
      setList(result);
      setloading(false);
    });
    setreload(false);
  }, [reload, pageno.current, page_size.current]);

  const attributeTreeData = attributes
  ? attributes.map(attr => ({
      title: attr.name,
      value: attr.id,
      key: attr.id,
      children: attr.terms.map(term => ({
        title: term.name,
        value: term.id,
        key: term.id,
      })),
    }))
  : [];

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          setloading={setloading}
          total_data={total_data}
          User={User}
        />
      );
    }
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <h3>Enter Product SKU for Search</h3>
          <AutoComplete
            placeholder="input search text"
            // onChange={onChange}
            onKeyUp={onChange}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={4} offset={1}>
          <h3>Choose Location</h3>
          <Select
            placeholder="Please Select Location"
            style={{ width: "100%" }}
            onChange={(e) => {
              location.current = e;
              pageno.current = 1;
              setloading(true);
              setreload(true);
            }}
          >
            <Option value="">All</Option>
            {locations.map((outlet) => {
              return <Option value={outlet.id}>{outlet.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={4} offset={1}>
          <h3>Category Filter</h3>

          <TreeSelect
            style={{ width: "100%" }}
            treeData={categoryList}
            onChange={(value) => {
              pageno.current = 1;
              searchCategory.current = value;
              setloading(true);
              setreload(!reload);
            }}
          />
        </Col>
        <Col span={3} offset={1}>
          <h3>Attribute Filter</h3>
          <TreeSelect
            style={{ width: "100%" }}
            treeData={attributeTreeData}
            onChange={(value) => {
              pageno.current = 1;
              searchAttribute.current = value;
              setloading(true);
              setreload(!reload);
            }}
          />
        </Col>
        {/* <Col span={2} offset={1}>
        <h3>.</h3>
          <Button type="primary" style={{ width: "100%", marginRight: "4px" }} onClick={() => {
            setloading(true);
            setreload(!reload);
          }}>Search</Button>
        </Col> */}
        <Col span={6} offset={1}></Col>
      </Row>

      <Divider />
      {renderdata()}
    </>
  );
};
const mapStateToProps = (state) => {
  console.log("State:", state);
  return {
    // List: state.ProductDetails.productdetails,
    categoryList: state.category.categorylist,
    attributeTerms: state.attribute.attributeTerms,
    attributes: state.attribute.attributelist,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  getAllCategory,
  getAllAttributeTerm,
  getAllAttribute,
})(SearchStock);
